import { userMediaFailed } from 'features/user-media/userMediaSlice';
import { store } from 'store/store';
import { logger } from 'utils/logger';
import { isDomException } from 'utils/types';

// Reports a gUM denial to the permission slice, which drives the device toggle's error icon,
// recovery modal, and saga guards. A non-DOMException isn't a device-permission signal.
export const reportMediaCaptureFailure = (kind: MediaDeviceKind, error: unknown): void => {
  if (!isDomException(error)) {
    return;
  }

  logger
    .remote({ system: true, capture: 'user_media' })
    .error(`Media capture failed: ${error.name}: ${error.message}`);

  store.dispatch(
    userMediaFailed({
      kind,
      value: error.name === 'NotFoundError' ? 'not-found' : 'denied',
    })
  );
};
